import { AuthService } from '../shared/service/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const expectedRole = route.data.role;
    return this.auth.user.pipe(
      take(1),
      map(user => {
        if (!user) {
          this.router.navigateByUrl('/auth/login');
          return false;
        } else {
          let role = user['ouqRole'];
          if (role === expectedRole) {
            return true;
          } else if( role === "ADMIN") {
            this.router.navigateByUrl('/handbooks');
          } else if( role === "PVO") {
            this.router.navigateByUrl('/add-handbook');
          }else if( role === "PUBLISHINGDEP") {
            this.router.navigateByUrl('/publishing-dep');
          }else if( role === "KAFEDRA") {
            this.router.navigateByUrl('/fakultet');
          }else{
            alert('Foydalanuvchi rolini o\'zgartiring!');
            return false;
          }
        }
      })
    )
  }
}
